import { create } from "zustand";

const useSealStore = create((set) => ({
    seals: [], //seals to be mounted
    setSeals: (value) => set((state) => ({...state, seals: value}))
}));

export default useSealStore;
